import { render, staticRenderFns } from "./NotificationModal.html?vue&type=template&id=28e946a5&external"
import script from "./NotificationModal.ts?vue&type=script&lang=ts&external"
export * from "./NotificationModal.ts?vue&type=script&lang=ts&external"
import style0 from "./NotificationModal.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports